module.exports = __webpack_public_path__ + "img/especies.04938124.svg";